<template>
    <div>
        <div v-if="showBuyTCTips" class="layui-layer-shade" id="layui-layer-shade2" times="2"
            style="z-index: 19891015; background-color: rgb(0, 0, 0); opacity: 0.3;"></div>
        <div v-if="showBuyTCTips" class="layui-layer layui-layer-page" type="page" times="3" showtime="0" contype="string"
            style="z-index: 19891077;top:50%; left: 50%;width:262px;heigt:160px;margin-left:-115px;margin-top:-80px;">
            <div class="layui-layer-title">温馨提示</div>
            <div id="layerDemoauto" class="layui-layer-content ng-scope">
                <div style="padding: 20px 20px;font-size:14px;" id="layui-layer-info">{{ showTipsCont }}</div>
            </div>
            <span class="layui-layer-setwin" v-on:click="canelBuyTCTips">
                <a class="layui-layer-ico layui-layer-close layui-layer-close1" href="javascript:;"></a>
            </span>
            <div class="layui-layer-btn layui-layer-btn-c" style="border-top:1px solid #eee;">
                <a class="layui-layer-btn0" v-on:click="buyZeroUi">确定</a>
                <a class="layui-layer-btn0" v-on:click="canelBuyTCTips"
                    style="color: #333;background: none;border: 1px solid #dedede;">取消</a>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    data() {
        return {
            showBuyTCTips: false,
            showBuyTCInfos: null,
            showTipsCont: '',
            showCurType: null,
        };
    },
    methods: {
        // 购买
        getContentFrom(data) {
            this.showTipsCont = data.cont;
            this.showBuyTCInfos = data.item;
            this.showCurType = data.type;
            this.purchaseUi();
        },
        purchaseUi() {
            this.showBuyTCTips = true;
        },
        canelBuyTCTips: function () {
            this.showBuyTCTips = false;
            this.showBuyTCInfos = null;
        },
        buyZeroUi: function () {
            this.showBuyTCTips = false;
            this.buyCopyServerProcess();
        },
        buyCopyServerProcess() { 
            let _this = this;
            let curI = this.showBuyTCInfos;
            let cdkey = $.trim($("input[name=cdkey]").val());
            if(!/^[a-z0-9]{12,12}$/.test(cdkey)){
                cdkey = "";
            }
            let userId = $.cookie('mmdId');
            let reqData = {};
            let tipsn = '';
            if (this.showCurType == 'dsh') {
                tipsn = '大屏';
                let iid = curI.iid?curI.iid:'';
                reqData = {
                    "userId": userId,
                    "iid": iid,
                    "type": 'ThingStore_Ui',
                    "paySource":'http://store.thingjs.com/charts',
                    "cdkey":cdkey,
                    "payment" : 'modou',
                }
            }else if(this.showCurType == 'map_plate'){
                tipsn = '城市';
                let iid = curI.id?curI.id:'';
                reqData = {
                    "userId": userId,
                    "iid": iid,
                    "type": 'ThingStore_City',
                    "paySource":'http://store.thingjs.com/cities',
                    "cdkey":cdkey,
                    "payment" : 'modou',
                }
            }else if(this.showCurType == 'thingxPro'){
                tipsn = '零代码';
                let iid = curI.cid?curI.cid:'';
                reqData = {
                    "userId": userId,
                    "iid": iid,
                    "type": 'ThingStore_ZeroCode',
                    "paySource":'http://store.thingjs.com/projects',
                    "cdkey":cdkey,
                    "payment" : 'modou',
                }
            }
            _this.$reqs.post("/purchaseRes/purchaseUI", reqData).then(function (result) {
                if (result.data && result.data.state) {
                    _this.$Message.success(tipsn+'资源复制完成！');
                    console.log(tipsn+'资源复制完成！');
                    _this.showBuyTCInfos = null;
                    if(_this.showCurType == 'thingxPro'){
                        let id = result.data.content.dataFieldId;
                        window.open(`https://thingjsx.thingjs.com/thing/?domainId=${id}`, '_blank');
                    }
                    return;
                } else {
                    _this.$Message.success(tipsn+'资源复制失败！');
                    console.log(tipsn+'资源复制失败！');
                    _this.showBuyTCInfos = null;
                    return;
                }
            }).catch(function (error) {
                console.log("接口调用失败！" + error);
                _this.showBuyTCInfos = null;
            });
            return;
        },
    },
}
</script>


// WEBPACK FOOTER //
// src/components/panelTips/purchaseTips.vue